/* Fransk katalog for locale-bank-kje09-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'bank.group.toast.booked': 'Le groupe de rapprochement a été comptabilisé en une fois.',
  'bank.group.err.bookUnavailable': 'Le groupe de rapprochement a été approuvé, mais la comptabilisation n\'est pas disponible.',
  'bank.group.err.bookFailed': 'Impossible de comptabiliser le groupe de rapprochement.',
  'bank.group.book': 'Comptabiliser le groupe',
  'bank.resolve.reversePaymentInfo': 'L\'extourne annule le paiement avec une piste d\'audit, rouvre la facture fournisseur et rouvre la ligne bancaire pour un nouveau contrôle.',
  'err.bankMatchReversalReason': 'Indiquez le motif de l\'annulation du rapprochement bancaire.',
});
